import { Navigate, Outlet, useLocation } from "react-router-dom";

import { NoAccess } from "@/components/common/no-access";
import {
  canAccessRoute,
  findRoutePermission,
  getFallbackRoute,
} from "@/config/routes";
import { useRoles } from "@/hooks/useRoles";

/**
 * Route guard component that checks user roles against route permissions.
 * A page the role lacks the permission for says so in place, so a shared link
 * explains itself; anything else, an unknown path included, goes Home.
 */
export const RoleRoute = () => {
  const { pathname } = useLocation();
  const roles = useRoles();

  if (canAccessRoute(pathname, roles)) return <Outlet />;

  const route = findRoutePermission(pathname);

  if (roles.workspaceRole && route && "permission" in route) {
    return (
      <NoAccess
        className="flex-1 justify-center"
        permission={route.permission}
      />
    );
  }

  return <Navigate replace to={getFallbackRoute()} />;
};
